export default () => {
	const LAMBDA_URL = document.querySelector('meta[name="sumo:signup_url"]').content || '';
	const url = new URL(`${LAMBDA_URL}/providers/`);
	const headers = new Headers({
		'Content-Type': 'application/json',
	});
	const options = {
		method: 'POST',
		body: JSON.stringify(['']),
		headers,
	};
	const req = new Request(url, options);

	return fetch(req).then((response) => {
		if (!response.ok) {
			throw new Error(response);
		}

		return response.json();
	});
}
